import React from 'react'
import { ArrowRightIcon, CheckIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../interaxDesignSystemComponents'
import { TESTIDS } from '../../../../config/testids'
import { PlatformTourCard } from './PlatformTourCard'

interface PlatformTourDoneProps {
  isOnboardingFinished: boolean
  onContinue: () => void
  onReplay: () => void
}

/** After the last stop: on to the dashboard, or back to onboarding while it is unfinished. */
export const PlatformTourDone: React.FC<PlatformTourDoneProps> = ({ isOnboardingFinished, onContinue, onReplay }) => {
  const { t } = useTranslation()
  const continueLabel = isOnboardingFinished
    ? t('gamer.platformTour.goToDashboard')
    : t('gamer.platformTour.goToOnboarding')

  return (
    <PlatformTourCard
      icon={<CheckIcon />}
      title={t('gamer.platformTour.doneTitle')}
      body={t('gamer.platformTour.doneBody')}
    >
      <Button
        variant="primary"
        icon={<ArrowRightIcon className="w-4 h-4" />}
        iconPosition="right"
        onClick={onContinue}
        data-testid={TESTIDS.PLATFORM_TOUR_CONTINUE_BTN}
      >
        {continueLabel}
      </Button>
      <Button variant="secondary" onClick={onReplay} data-testid={TESTIDS.PLATFORM_TOUR_REPLAY_BTN}>
        {t('gamer.platformTour.replayTour')}
      </Button>
    </PlatformTourCard>
  )
}
